import { Component, OnInit, ViewContainerRef, ViewChild, ElementRef } from '@angular/core';

import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { TranslateService } from 'ng2-translate';

import { ProjectsService } from '../services/projects.service';
import { IssuesService } from '../../issues/services/issues.service';
import { AlertManagerService } from '../../../shared/services/alert-manager.service';

import { Version } from '../../../modules/models/version';
import { WorkConstants } from '../work.const';
import { BaseChartDirective } from 'ng2-charts/ng2-charts';

@Component({
  selector: 'app-projectdetails',
  templateUrl: './projectdetails.component.html',
  providers: [ProjectsService]
})
export class ProjectdetailsComponent implements OnInit {
  @ViewChild(BaseChartDirective) chart: BaseChartDirective;

  project: any = {};
  projectId: number;
  sprintId: number = 0;

  styleDisplay: string = "none";

  sprints: Array<any> = [];
  stories: Array<any> = [];
  formData: any = {};
  issueFormData: any = {};
  issueProjectData: any = {};
  issueId: number;
  isShowView: any;
  issues: any = [];
  subTasks: Array<Array<any>> = [];
  isShowFaIcon: Array<boolean> = [];
  projectDetail: any = {};

  dyanamicModalHeader: string;
  dyanamicModalField: string;
  timeLine: any = [];

  defaultPageId: number = 1;

  dyanamicComponent: string;
  version: Version = new Version();
  private versionList: any;

  private componentList: Array<any> = [];
  private tempComponentList: Array<any> = [];

  isShowIssueCreater: boolean = false;

  workConstants: any = WorkConstants;

  //story
  storyPageId: number = 1;
  storyPerPage: number = 0;
  storyCount: number = 0;
  storyPageCount: number = 1;
  

  burndown: any = {
    actual_line: [],
    ideal_line: [],
    spent_line: [],
    x_axis: []
  };

  public lineChartColors:Array<any> = [
    { 
      backgroundColor: 'rgba(57, 156, 58, 0.2)',
      borderColor: 'rgba(57, 156, 58, 1)'
    },
    { 
      backgroundColor: 'rgba(224, 21, 21, 0.2)',
      borderColor: 'rgba(224, 21, 21, 1)'
    },
    {
      backgroundColor: 'rgba(19, 68, 167, 0.2)',
      borderColor: 'rgba(19, 68, 167, 1)'
    }
  ];

  constructor(
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private projectsService: ProjectsService,
    private alertService: AlertManagerService,
    private translate: TranslateService,
    private issuesService: IssuesService
  ) { }

  ngOnInit() {
    this.setUrlParams();
    this.getProjectById();
    this.getStories(this.storyPageId);

    // this.getSprints(this.sprintPageId);
  }

  openBacklog() {
    this.styleDisplay = this.styleDisplay === 'none' ? 'block' : 'none';
  }

  // openIssueCreater(issue?: any, isShowView?: any) {
  //   this.issueId = issue ? issue.id : null;
  //   this.isShowView = isShowView ? isShowView : false;
  //   this.isShowIssueCreater = true;
  // }

  closeIssueCreater() {
    this.isShowIssueCreater = false;
    // this.getIssuesForProject();
  }

  setUrlParams() {
    this.activatedRoute.params.subscribe(
      (param: any) => {
        this.projectId = param.id ? param.id : -1;
      });
  }

  onChangeSprint(sprintId, taskId, type) {
    let body = { task_id: taskId, type: type };
    this.projectsService.addTaskToSprint(sprintId, body).subscribe(
      success => {
        if (success.data.exceeded_hours) {
          this.alertService.warning({ title: "WARNING", msg: success.data.exceeded_hours + " Exceeded Hours" });
          // this.toastr.warning(success.data.exceeded_hours+" Exceeded Hours");
        } else {
          this.alertService.success({ title: "SUCEESS", msg: "Successfully added sprint" });
          // this.toastr.success("Successfully added sprint");
        }
      }
    );
  }

  /**
   * get project details by project Id
   */
  getProjectById() {
    console.log('fist', this.projectId);
    this.projectsService.getProjectById(this.projectId).subscribe(
      project => {
        this.project = project.project;
      }
    );
  }

  /**
   * get all sprint in project
   */
  // getSprints(sprintPageId) {
  //   if(!sprintPageId){// if sprint page id is undifine
  //     sprintPageId = this.sprintPageId;
  //   }
  //   this.projectsService.getSprints(this.projectId,sprintPageId).subscribe(
  //     sprints => {
  //       this.sprints = sprints.data.data;
  //       this.sprintPageId = sprints.data.current_page
  //       this.sprintCount = sprints.data.total
  //       this.sprintPageCount = sprints.data.last_page
  //     }
  //   );
  // }

  /**
   * get all story in project
   */
  getStories(pageId) {
    this.subTasks = [];
    this.isShowFaIcon = [];
    this.projectsService.getStories(this.projectId,pageId).subscribe(
      stories => {
        if(stories.data && stories.data.data){
        this.stories = stories.data.data;
        this.storyPerPage = stories.data.per_page
        this.storyPageId = stories.data.current_page
        this.storyCount = stories.data.total
        this.storyPageCount = stories.data.last_page
        }
        this.getFormdata();
        this.scrollThePage();
      }
    );
  }

  /**
   * get task in story
   * show,hide table story task
   */
  getSubTasks(storyId, index, isReset) {
    if (this.subTasks[index] && !isReset) {
      this.subTasks[index] = null;
      this.isShowFaIcon[index] = false;
    } else {
      this.projectsService.getSubTasks(storyId).subscribe(
        subTasks => {
          this.subTasks[index] = subTasks.data;
          if (subTasks.data.length <= 0) {
            this.alertService.warning({ title: this.translate.instant("WARNING"), msg: this.translate.instant('STORY_TASK_ARE_NOT_DEFINED') });
          } else {
            this.isShowFaIcon[index] = true;
          }
        }
      );
    }
  }

  getBacklogData(event) {
    if (event) {
      this.getSubTasks(event.id, event.i, true);
    } else {
      this.getStories(this.storyPageId);
    }
  }

  /**
   * get all form data
   */
  getFormdata() {
    this.projectsService.getTaskFormData(this.projectId, 3).subscribe(
      formData => {
        this.formData = formData.data;
      }
    );
  }

  getTimeLine() {
    this.projectsService.getTimeLine(this.projectId).subscribe(
      timeLine => {
        this.timeLine = timeLine.data;
      }
    );
  }

  getProjectDetails() {
    this.projectsService.getProjectDetails(this.projectId).subscribe(
      res => {
        this.projectDetail = res.data;
      }
    );
  }

  // getIssuesForProject() {
  //   this.isShowIssueCreater = false;
  //   this.issuesService.getIssuesForProject(this.projectId).subscribe(
  //     res => {
  //       this.issues = res.data;
  //     }
  //   );
  // }


  /**
   * lineChart
   */
  public lineChartData: Array<any> = [
    { data: this.burndown.ideal_line, label: 'Ideal velocity', lineTension: 0, fill: false },
    { data: this.burndown.actual_line, label: 'Left time', lineTension: 0, fill: false },
    { data: this.burndown.spent_line, label: 'Spent time', lineTension: 0, fill: false },
  ];

  public lineChartLabels: Array<any> = [];

  public lineChartOptions: any = {
    responsive: true,
  };

  public lineChartLegend: boolean = true;
  public lineChartType: string = 'line';
  // lineChart end

  getSprintBundrownChart() {

    this.sprintId = this.getCurrentSprint() ? this.getCurrentSprint().id : this.sprints[this.sprints.length - 1].id;
    this.projectsService.getSprintBundrownChart(this.sprintId).subscribe(
      res => {
        if (res) {
          this.burndown = res.data;
          this.lineChartData = [
            { data: this.burndown.ideal_line, label: 'Ideal velocity', lineTension: 0, fill: false },
            { data: this.burndown.actual_line, label: 'Left time', lineTension: 0, fill: false },
            { data: this.burndown.spent_line, label: 'Spent time', lineTension: 0, fill: false },
          ];
          this.lineChartLegend = true;
          this.lineChartLabels = this.burndown.x_axis;
          if (this.chart && this.chart.chart && this.chart.chart.config) {
            this.chart.chart.config.data.labels = this.burndown.x_axis;
            this.chart.chart.update();
          }
        }
      }
    );
  }

  getCurrentSprint() {
    let currentDate = new Date().getTime();
    let currentSprint = this.sprints.filter(sprint => {
      let startDate = new Date(sprint.start_date).getTime();
      let endDate = new Date(sprint.end_date).getTime();
      return startDate <= currentDate && endDate >= currentDate;
    });
    return currentSprint[0];
  }

  // events
  public chartClicked(e: any): void {
    console.log(e);
  }

  public chartHovered(e: any): void {
    console.log(e);
  }

  /**
   * kauhslya
   * 2017-08-03
   * change the page according to the pagination event
   * @param event
   */
  storyPageChanged(event){
    this.getStories(event);
  }

  /**
   * kauhslya
   * 2017-08-14
   * scroll The Page
   * @param event
  //  */
  scrollThePage(){
    window.scrollTo(0,0);
  }
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

}



// WEBPACK FOOTER //
// ./src/app/modules/work/components/projectdetails.component.ts